import styles from './Video.module.css';

export const Video = ({ srcVideo }) => {
  return (
    <video autoPlay="autoplay" muted="muted" className={styles.mobileVideo}>
      <source src={srcVideo} type="video/webm" />
    </video>
  );
};
